<template>
    <form-view class="ar-create-view" @submiterror="resetPageType" @submitsuccess="handleRedirect">
        <veui-steps
            :steps="store.stepsInfo.data"
            :current="store.stepsInfo.current"
            v-if="store.stepsInfo.data.length"/>
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                v-if="!showAderName"
                :readonly="isAppFixed || !isCreate"
                rules="required">
                    <search-select
                        :options="store.appListDatasource"
                        :readonly="isAppFixed || isEdit"
                        v-model="store.formData.appId"
                        placeholder="请选择"/>
                        <veui-button v-if="!isEdit" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
            <veui-field v-if="showAderName" name="aderName" field="aderName" label="广告主名称：" rules="required">
                <veui-input readonly v-if="isAderNameReadonly" v-model="store.formData.aderName" />
                <search-select
                    v-else
                    :options="store.aderList"
                    v-model="store.formData.aderName"
                    placeholder="请选择"/>
            </veui-field>
            <veui-field label="服务名称：" name="name" field="name" :rules="[
                {
                    name: 'maxLength',
                    value: 50,
                    triggers: 'blur,input'
                }
            ]">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="不填则由系统生成"/>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button v-if="canSaveAndContinue" ui="primary" type="submit">保存并继续</veui-button>
            <veui-button ui="aux" @click="back">返回</veui-button>
        </template>
    </form-view>
</template>

<script>
import {get, find} from 'lodash';
import FormModel from './FormModel';
import FormView from '@baidu/ve-ria/views/FormView';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Input} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';

export default createView(FormView, FormModel, {
    name: 'ARCreateView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-button': Button,
        'veui-steps': Steps,
        SearchSelect
    },
    computed: {
        isAppFixed() {
            return this.$route.params.appId;
        },
        isEdit() {
            return this.store.pageType === 'edit';
        },
        isCopy() {
            return this.store.pageType === 'copy';
        },
        isCreate() {
            return this.store.pageType === 'create';
        },
        prefix() {
            return this.store.isAdmin ? '' : '/app';
        },
        canSaveAndContinue() {
            const pageType = this.store.pageType;
            const status = get(this, 'store.formData.status');
            if (pageType === 'create' || pageType === 'copy') {
                return true;
            }
            return status === 'DRAFT' || status === 'REJECT';
        },
        isAderNameReadonly() {
            return this.aderName && this.store.aderList.length === 0;
        },
        showAderName() {
            const hasAppId = get(this, 'store.formData.appId');
            const noAppList = this.store.isAder && this.store.appListDatasource.length === 0;
            return !hasAppId && noAppList;
        },
        aderName() {
            const defaultAderName = this.store.getRouteQuery().aderName;
            const aderName = this.store.isAder ? this.store.getDev().userName : defaultAderName;

            return aderName;
        }
    },
    async created() {
        await this.store.requestAppList();
        this.fillData();
    },
    methods: {
        handleRedirect(data) {
            const {templateId, tempType}  = this.store.formData;
            let url = `${this.prefix}/service/${data.id}/ar/template/list?`;
            const query = `templateId=${templateId}&templateType=${tempType}`;
            if (!this.isCreate) {
                const serviceId = this.$route.params.serviceId;
                if (this.isEdit && !this.store.isMaterial) {
                    url = `${this.prefix}/service/${serviceId}/ar/case/edit?`;
                }
                else {
                    url = `${this.prefix}/service/${serviceId}/ar/template/list?${query}&`;
                }
            }
            this.global.redirect({
                url: `${url}type=${this.store.pageType}`,
                type: 'push'
            });
        },
        goToCreateApp() {
            this.global.redirect({
                url: {
                    path: '${this.prefix}/create'
                },
                type: 'push'
            });
        },
        resetPageType() {
            this.store.pageType = this.store.getRoutePath().split('/').pop();
        },
        // 有几种情况，分别是路由参数带了 appId，没带 appId， 有 aderName，无 aderName 等等
        // 若路由参数没有 appId, 则需判断是否有 aderName，若没有则分成以下几种情况
        // 1. 无 appList， 此时需要请求 aderList，根据 aderName 创建服务
        // 2. 有 appList 则直接把第一个 app 设置为默认 appId
        // 3. 若 appList 和 aderName 同时存在，则需要过滤出某个广告主下的 appList
        fillData() {
            const appId = get(this, 'store.formData.appId');
            const appList = get(this, 'store.appListDatasource', []);

            if (!appId) {
                if (!this.aderName && !appList.length) {
                    this.store.requestAderList();
                }
                else if (!this.aderName && appList.length) {
                    this.store.appId = appList[0].value;
                }
                else if (this.aderName && appList.length) {
                    const app = find(appList, app => app.aderName === this.aderName);
                    if (app) {
                        this.store.formData.appId = app.value;
                        this.store.appListDatasource = this.store.isAder
                            ? appList
                            : appList.filter(app => app.aderName === this.aderName);
                    }
                }
            }
            else {
                // 其他逻辑
                this.store.aderList = [];
            }
            this.store.formData.aderName = this.aderName;
        }
    }
});
</script>
<style lang="less">
.ar-create-view {
    .veui-select {
        min-width: 210px;
    }
    .veui-steps-step {
        margin-right: 100px;

        &:after {
            width: 90px;
            right: -95px;
        }
    }
}
</style>

